import { Image } from '@grupoboticario/flora-react';

import { Picture } from './PrismicPicture.styles';
import { getSourceFromImageContent } from '../helpers';

import type { ImageWithDevices } from 'domains/content.d';

export const PrismicPicture = ({ image }: { image?: ImageWithDevices }) => {
  if (!image) return null;

  const { alt, url } = image;
  const sources = getSourceFromImageContent(image);

  return (
    <Picture.Wrapper data-testid='picture'>
      {sources.map((sourceItem, index) => (
        <source
          key={`${sourceItem.srcSet}-${index}`}
          media={sourceItem.media}
          srcSet={sourceItem.srcSet}
        />
      ))}
      <Image alt={alt ?? ''} src={url ?? ''} title={alt ?? ''} />
    </Picture.Wrapper>
  );
};
